"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFlavorPickerItems = exports.fetchCustomMenuPrice = exports.fetchUpsell = exports.fetchCustomImages = exports.fetchCustomMenu = exports.fetchNutrition = exports.fetchMenu = void 0;

var _tslib = require("tslib");

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _api = require("../api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var fetchMenu = function fetchMenu(locationNumber, serviceMethod) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get("v4"
      /* Menu */
      + "/stores/" + locationNumber + "/" + serviceMethod + "/" + "menu"
      /* Menu */
      ).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchMenu = fetchMenu;

var fetchNutrition = function fetchNutrition(nutritionKey) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get("nutritions"
      /* Nutrition */
      + "?nutritionKey=" + nutritionKey).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchNutrition = fetchNutrition;

var fetchCustomMenu = function fetchCustomMenu(customMenuRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v2"
      /* CustomMenu */
      + "/" + "stores/customMenu"
      /* CustomMenu */
      , customMenuRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchCustomMenu = fetchCustomMenu;

var fetchCustomImages = function fetchCustomImages(customImagesRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("stores/customImages"
      /* CustomImages */
      , customImagesRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchCustomImages = fetchCustomImages;

var fetchUpsell = function fetchUpsell(req) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("/stores/" + req.locationNumber + "/menu/" + "v2"
      /* Upsell */
      + "/" + "upsell"
      /* Upsell */
      , {
        cart: req.cart
      }).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchUpsell = fetchUpsell;

var fetchCustomMenuPrice = function fetchCustomMenuPrice(req) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("stores/customMenuPrice"
      /* CustomMenuPrice */
      , req).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchCustomMenuPrice = fetchCustomMenuPrice;

var fetchFlavorPickerItems = function fetchFlavorPickerItems(locale) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    var location;
    return (0, _tslib.__generator)(this, function (_a) {
      location = typeof window !== 'undefined' && window.location && window.location.origin;
      return [2
      /*return*/
      , _api.api.get(location + "/" + "config/flavorPicker.json"
      /* FlavorPickerItems */
      ).then(function (res) {
        var _a;

        var flavorPickerByLocale = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a[locale];

        if (!(0, _isArray2["default"])(flavorPickerByLocale)) {
          return [];
        }

        return flavorPickerByLocale;
      })];
    });
  });
};

exports.fetchFlavorPickerItems = fetchFlavorPickerItems;